import {Injectable, inject} from '@angular/core';

import {Cart} from '@features/sales/domain/entities/cart/cart.entity';
import {Product} from '@features/sales/domain/models/product/product.model';
import {AddToCartOptions} from '@features/sales/domain/models/cart/item.model';
import {CartCommandService} from '@features/sales/application/store/cart/cart-command.service';
import {CartQueryService} from '@features/sales/application/store/cart/cart-query.service';
import {CartItemFactory} from '@features/sales/application/factories/cart-item.factory';
import {CartTotalChangedEvent} from '@platform/event-bus/domain/events/cart/cart-total-changed.event';
import {EventBusPort} from '@platform/event-bus/domain/ports/event-bus.port';

@Injectable({providedIn: 'root'})
export class AddItemToCartUseCase {
  private readonly eventBus = inject(EventBusPort);
  private readonly cartQuery = inject(CartQueryService);
  private readonly cartCmd = inject(CartCommandService);
  private readonly cartItemFactory = inject(CartItemFactory);

  execute(product: Product, quantity = 1, options?: AddToCartOptions): void {
    const {isLocked, items} = this.cartQuery.snapshot();

    if (isLocked || quantity <= 0) {
      return;
    }

    const cart = new Cart(items);
    const item = this.cartItemFactory.fromProduct(product, quantity, options);

    cart.addItem(item);

    this.cartCmd.apply(cart);
    this.eventBus.publish(new CartTotalChangedEvent({newTotal: cart.totalPrice}),
    );
  }
}
